import { useEffect } from "react";

import { useAtom, useAtomValue, useSetAtom } from "jotai";
import { chatHistoryAtom, chatIdAtom, selectedClientAtom } from "store";

import { useGetChatSessionId } from "state/useGetChatSessionId";

// import { useAllUserDocumentsForChatbot } from "./useAllUserDocumentsForChatbot";
import { useAllUserDocumentsForChatbotNew } from "./useAllUserDocumentsForChatbotNew";
import { usePrevious } from "./usePrevious";

export function useChatSessionId() {
  const allDocuments = useAllUserDocumentsForChatbotNew();
  const selectedCompany = useAtomValue(selectedClientAtom);
  const [chatId, setChatId] = useAtom(chatIdAtom);
  const setChatHistory = useSetAtom(chatHistoryAtom);

  const { mutate: getChatId, isLoading } = useGetChatSessionId();
  const prevChatId = usePrevious(chatId);

  const prevSelectedCompany = usePrevious(selectedCompany) as any;

  const fetchSessionId = () => {
    getChatId(allDocuments || [], {
      onSuccess: (id) => {
        setChatId(id);
      },
    });
  };
  useEffect(() => {
    if (
      isLoading ||
      !allDocuments ||
      chatId === prevChatId ||
      selectedCompany?.clientName === prevSelectedCompany?.clientName
    )
      return;
    setChatId(null);
    setChatHistory([]);
    fetchSessionId();
  }, [allDocuments, selectedCompany]);
}
